// @flow weak
import React        from 'react';
import PropTypes    from 'prop-types';
import UserMenu     from './userMenu/UserMenu';
import TaskMenu     from './taskMenu/TaskMenu';
import MessageMenu  from './messageMenu/MessageMenu';
import Button       from './button/Button';
import ViewLink                             from '../../components/aside/asideLeft/menu/menuLinks/viewLink/ViewLink.js';
import { Link }         from 'react-router-dom';
const Header = ({
  userLogin,
  userFirstname,
  userLastname,
  userPicture,
  showPicture,
  appName,
  currentView,
  toggleSideMenu,

  onLogout,
  sideMenu,
  superUser,
  partner,
  accessConfig,
}) => (
  <header
    className="header fixed--header">
    <a href="#" style={{backgroundImage: 'linear-gradient( 91.7deg,  #12037C 44.3%, rgb(117 105 202) 101.8% )',fontWeight:'bold'}}
      className="logo hidden-xs">
      { appName }
    </a>
    <div className="navbar navbar-static-top" role="navigation" >

      <Button
        toggleSideMenu={toggleSideMenu}
      />

      <div className="top-navigation-menu" style={{backgroundImage: 'linear-gradient( 91.7deg,  #12037C 44.3%, rgb(117 105 202) 101.8% )'}}>

        <div style={{display:'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
          <div>
          {/*{ localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_cm_workbench') && accessConfig != 'Technichal Partner' ?
          (<ViewLink
            key={'0'}
            isActive={true}
            linkTo={'/work-bench'}
            viewName={'Workbench'}
            faIconName={'fa-tasks'}
            itemCount= {0}
            label= {'Workbench'}
          />)
          :
          ('')
        }
          { localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_cm_dashboard') && accessConfig != 'Technichal Partner' ?
          (<ViewLink
            key={'1'}
            isActive={true}
            linkTo={'/dashboard/ActiveCustomer'}
            viewName={'Dashboard'}
            faIconName={'fa-bar-chart'}
            itemCount= { 0}
            label= {'Dashboard'}
          />)
          :
          ('')
        }
        
          { localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_cm_rental') && accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'2'}
            isActive={true}
            linkTo={'/partnerCourtBooking'}
            viewName={'Rental'}
            faIconName={'fa-registered'}
            itemCount= { 0}
            label= {'Rental'}
          />)
            :
            ('')

          }
        

          { localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_cm_marketing_removed') && accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'5'}
            isActive={true}
            linkTo={'/marketing'}
            viewName={'Marketing'}
            faIconName={'fa-bullhorn'}
            itemCount= { 0}
            label={'Marketing'}
          />)
            :
            ('')

          }
        

          { localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_cm_event') && accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'7'}
            isActive={true}
            linkTo={'/partnerTournament'}
            viewName={'Events'}
            faIconName={'fa-trophy'}
            itemCount= { 0}
            label={'Events'}
          />)
            :
            ('')
          }

          { localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_cm_venue') && accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'8'}
            isActive={true}
            linkTo={'/venueLanding'}
            viewName={'Venue'}
            faIconName={'fa-map-marker'}
            itemCount= { 0}
            label={'Venue'}
          />)
            :
            ('')
          }

          { localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_cm_inventory') && accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'9'}
            isActive={true}
            linkTo={'/inventory'}
            viewName={'Inventory'}
            faIconName={'fa-map-marker'}
            itemCount= { 0}
            label={'Inventory'}
          />)
            :
            ('')
          }*/}
        
          </div>




          <div style={{float:'right'}}>
            <Link style={{marginRight: '5%', padding: '2%'}}
                    to={'/login'}
                    onClick={onLogout}
                    >
                    <span style={{fontSize: '14px'}}>
                      {'Logout'}
                    </span>
            </Link>
          </div>




        </div>
      </div>

    </div>

  </header>
);
Header.propTypes = {
  appName:        PropTypes.string,
  userLogin:      PropTypes.string,
  userFirstname:  PropTypes.string,
  userLastname:   PropTypes.string,
  userPicture:    PropTypes.string,
  showPicture:    PropTypes.bool,
  onLogout:       PropTypes.func,
  currentView:    PropTypes.string,
  toggleSideMenu: PropTypes.func
};
Header.defaultProps = {
  appName: 'applicationName'
};
Header.displayName = 'Header';
export default Header;



// WEBPACK FOOTER //
// ./src/app/components/header/Header.js